export const ALL_POST_TYPES = {
    NEWS: 'Post',
    SEC_FILING: 'Post::SecFiling',
    JOB_UPDATES: 'Post::JobUpdates',
};

const POST_TYPE_LABELS = {
    [ALL_POST_TYPES.NEWS]: 'News',
    [ALL_POST_TYPES.SEC_FILING]: 'SEC Filing',
    [ALL_POST_TYPES.JOB_UPDATES]: 'Job Update',
};

export const postTypeLabel = (post_type = ALL_POST_TYPES.NEWS) => {
    return POST_TYPE_LABELS[post_type];
};

const CONFIDENCE_TAB_LABELS = {
    high: 'High Confidence',
    mid: 'Mid Confidence',
    low: 'Low Confidence',
};

export const confidenceTabLabel = (tab) => {
    return CONFIDENCE_TAB_LABELS[tab];
};
